import React from "react"
import { Elements } from "prismic-reactjs"
import styled from "styled-components"
import { graphql } from "gatsby"
import ProductSliceZone from "components/SliceZone/Product"
import { getIconFromUrl } from "utils/iconResolver"
import Content from "components/Content"
import ProductPrice from "./Price"
import StylishIcon from "components/StylishIcon"
import Responsive from "components/Responsive"

const StyledSingleProduct = styled.article`
  position: relative;
  padding: 2rem 2rem 4rem;
  z-index: 10;

  h2 {
    margin: 0;
    text-transform: uppercase;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    max-width: 100rem;
    margin: 4rem auto;
    display: grid;
    grid-column-gap: 2rem;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas: "figure figure content content content";
    box-shadow: 0 20px 40px rgba(50, 50, 86, 0.25);
    background: ${props.theme.colors.white};
    border-radius: 10px;
    padding: 4rem;

    &:nth-child(odd) {
      grid-template-areas: "content content content figure figure";
    }
  `}
`

const StyledProductTitle = styled.h2`
  font-size: 1.8rem;
  display: inline-block;
  padding: 0.5rem 0;
  grid-area: content;
  color: ${(props) => props.theme.colors.primary};

  ${(props) => props.theme.media.tablet_landscape_up`
    font-size: 3.4rem;
  `}
`

const StyledPackage = styled.article`
  display: grid;
  grid-template-columns: 8rem 1fr;
  grid-column-gap: 2rem;
  grid-template-areas:
    "icon content"
    "icon content";

  .product-title {
    align-self: center;
    grid-area: content;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    grid-area: figure;

    display: flex;
    align-items: center;
    justify-content: center;

    .product-title {
      display: none;
    }
  `}
`

const StyledContent = styled.div`
  ${(props) => props.theme.media.tablet_landscape_up`
    grid-area: content;

    p {
      font-size: 1.7rem;
    }
  `}
`

const StyledProductIcon = styled(StylishIcon)`
  position: relative;
  display: block;
  margin: 1rem 0;
  grid-area: icon;

  ${(props) => props.theme.media.tablet_landscape_up`
    svg:last-child {
      transform: scale3d(.8, .8, .8);
      // opacity: 0.5;
    }
  `}
`

const htmlSerializer = function (type, element, content, children, key) {
  switch (type) {
    case Elements.heading1:
      return <StyledProductTitle key={key}>{children}</StyledProductTitle>
    default:
      return null
  }
}

function SingleProduct({ content: { product }, ...props }) {
  const {
    body,
    title,
    description,
    currency,
    text_after_price,
    text_before_price,
    regular_price,
    product_icon,
  } = product
  const icon = getIconFromUrl(product_icon.url)
  return (
    <StyledSingleProduct>
      <StyledPackage>
        <Responsive
          phone={<StyledProductIcon bg="blob-two" icon={icon} />}
          tabletLandscape={
            <StyledProductIcon size={30} bg="blob-two" icon={icon} />
          }
        />

        <Responsive
          phone={
            <header className="product-title">
              <Content content={title} serializer={htmlSerializer} />
            </header>
          }
          tabletLandscape={false}
        />
      </StyledPackage>
      <StyledContent>
        <Responsive
          tabletLandscape={
            <>
              <Content content={title} serializer={htmlSerializer} />
            </>
          }
        />
        <Content content={description} />
        <ProductSliceZone slices={body} />
      </StyledContent>
    </StyledSingleProduct>
  )
}

export default SingleProduct

SingleProduct.defaultProps = {}
SingleProduct.propTypes = {}

export const query = graphql`
  fragment SingleProductFragment on PRISMIC_Product {
    title
    description
    body {
      ... on PRISMIC_ProductBodyFeature_list {
        ...FeatureListFragment
      }
    }
    currency
    current_price
    current_price_expiry
    discount_text
    product_icon
    text_after_price
    text_before_price
    regular_price
  }
`
